"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var useSorts = function () {
    var _a = React.useState([]), sorts = _a[0], setSorts = _a[1];
    var addSort = function (sortToAdd) {
        var sortIndex = sorts === null || sorts === void 0 ? void 0 : sorts.findIndex(function (item) { return item.key === sortToAdd.key; });
        var sortExists = sortIndex && sortIndex >= 0;
        if (sortExists) {
            return;
        }
        setSorts(__spreadArray(__spreadArray([], sorts), [sortToAdd]));
    };
    var toggleSort = function (key) {
        var sortIndex = sorts.findIndex(function (item) { return item.key === key; });
        var sortExists = sortIndex >= 0;
        var replacementSorts = [];
        if (sortExists) {
            replacementSorts = sorts.map(function (sort, i) {
                return i === sortIndex
                    ? {
                        key: key,
                        direction: sorts[sortIndex].direction === 'ASC' ? 'DESC' : 'ASC',
                    }
                    : sort;
            });
        }
        else {
            replacementSorts = __spreadArray(__spreadArray([], sorts), [
                {
                    key: key,
                    direction: 'DESC',
                },
            ]);
        }
        setSorts(replacementSorts);
    };
    var removeSort = function (key) {
        var replacementSorts = sorts.filter(function (sort) { return sort.key !== key; });
        setSorts(replacementSorts);
    };
    var clearSorts = function () {
        setSorts([]);
    };
    return [sorts, addSort, removeSort, clearSorts, toggleSort];
};
exports.default = useSorts;
